import React from 'react';

interface GeoLocationProps {
  width?: string | number;
  height?: string | number;
  fill?: string;
}

const GeoLocation = ({ width = '16', height = '16', fill = '#4F4C4D' }: GeoLocationProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99998 12.9728C7.40276 11.8467 8.46874 10.7524 9.19792 9.6899C9.92708 8.6274 10.2917 7.6177 10.2917 6.66081C10.2917 5.85397 10.1457 5.16599 9.85388 4.59688C9.56201 4.02776 9.20028 3.56694 8.76867 3.2144C8.33706 2.86187 7.87217 2.60605 7.374 2.44694C6.87585 2.28784 6.42039 2.20829 6.00763 2.20829C5.59486 2.20829 5.13835 2.28784 4.6381 2.44694C4.13785 2.60605 3.67103 2.86187 3.23765 3.2144C2.80424 3.56694 2.441 4.02776 2.14792 4.59688C1.85483 5.16599 1.70829 5.85397 1.70829 6.66081C1.70829 7.6177 2.07287 8.6274 2.80204 9.6899C3.53122 10.7524 4.5972 11.8467 5.99998 12.9728ZM5.99998 14.6602C4.0972 13.2393 2.68401 11.8696 1.76042 10.5513C0.836806 9.23288 0.375 7.94011 0.375 6.67296C0.375 5.71586 0.54193 4.87671 0.875792 4.1555C1.20967 3.43431 1.64806 2.83172 2.19096 2.34775C2.73386 1.86378 3.34028 1.49733 4.01023 1.2484C4.68017 0.999466 5.34342 0.875 5.99998 0.875C6.67042 0.875 7.33715 0.999466 8.00015 1.2484C8.66315 1.49733 9.2661 1.86378 9.809 2.34775C10.3519 2.83172 10.7903 3.43431 11.1242 4.1555C11.458 4.87671 11.625 5.71586 11.625 6.67296C11.625 7.94011 11.1632 9.23288 10.2395 10.5513C9.31594 11.8696 7.90276 13.2393 5.99998 14.6602ZM6.00256 8.04163C6.41965 8.04163 6.77348 7.89547 7.06406 7.60317C7.35466 7.31085 7.49996 6.95615 7.49996 6.53906C7.49996 6.12198 7.35381 5.76815 7.0615 5.47756C6.76918 5.18697 6.41448 5.04167 5.9974 5.04167C5.58031 5.04167 5.22648 5.18782 4.9359 5.48013C4.6453 5.77245 4.5 6.12715 4.5 6.54423C4.5 6.96131 4.64615 7.31515 4.93846 7.60573C5.23078 7.89633 5.58548 8.04163 6.00256 8.04163ZM0.375 17.125V15.7917H11.625V17.125H0.375Z"
        fill={fill}
      />
    </svg>
  );
};

export default GeoLocation;
